//  For each product on the page
document.querySelectorAll('.productV2').forEach(section => {

    const product = JSON.parse(section.querySelector(".productV2JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = section.querySelector('.productV2QuantitySelectItemInput:checked')?.value || 1;

    // product has subscription
    const hasSubscription = product.selling_plan_groups.length > 0;


    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.productV2 = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

        // if single image instead of swiper, don't load
    let swiperExists = false;
    let multipleSwipers = false;
    let productSwiper;
    if (!section.querySelector('.productV2VisualSingle')) {

        // if multiple swiper elements for variants
        if (section.querySelector('.productV2VisualAlt')) {
            // mark this for image change
            multipleSwipers = true;
            section.querySelector('.productV2VisualAlt').querySelectorAll('.productV2VisualSwiper').forEach(swiper => {
                // each gets a swiper
                const variantSwiper = new Swiper(swiper, {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    autoHeight: true,
                });

                // change slide on thumbnail click
                swiper.nextElementSibling?.querySelectorAll(".productV2VisualThumbsSlide")?.forEach(element => {
                    element.addEventListener("click", function () {
                        // change slide
                        variantSwiper.slideTo(this.dataset.index - 1);
                    });
                });
            })
        } else {
            // mark these
            swiperExists = true;

            productSwiper = new Swiper(section.querySelector(".productV2VisualSwiper"), {
                slidesPerView: 1,
                spaceBetween: 20,
                autoHeight: true,
                on: {
                    slideChange: function () {
                        if (!section.querySelector(".productV2VisualSwiperSlide")) {
                            return;
                        }

                        // pause all videos
                        section.querySelectorAll(".productV2VisualSwiperSlide video").forEach(element => {
                            element.pause();
                        });
                    }
                }
            });

            // play video on slide play click
            section.querySelectorAll(".productV2VisualSwiperSlide")?.forEach(element => {
                element.addEventListener("click", function () {
                    // get video
                    const video = this.closest(".productV2VisualSwiperSlide").querySelector("video");

                    if (!video) {
                        return;
                    }

                    // remove play button if it hasn't already been removed
                    this.querySelector(".productV2VisualSwiperSlidePlay")?.remove();

                    // show controls
                    video.controls = true;

                    // play video
                    video.play();
                });
            });

            // change slide on thumbnail click
            section.querySelectorAll(".productV2VisualThumbsSlide")?.forEach(element => {
                element.addEventListener("click", function () {
                    // change slide
                    productSwiper.slideTo(this.dataset.index - 1);
                });
            });
        }
    }

    /**************
     Scarcity popups
     ***************/

    if (section.querySelector('.productV2VisualScarcity')) {
        // gather items and number
        const viewing = section.querySelectorAll('.productV2VisualScarcityViewing');
        const viewingPool = viewing.length;
        const adds = section.querySelectorAll('.productV2VisualScarcityAdd');
        const addsPool = adds.length;

        // load random popups, keep track in session storage to show other randoms
        setTimeout(() => {
            // show random viewing item that has not been seen this session, if all have been reused, reset
            let usedViews = JSON.parse(sessionStorage.getItem('views')) || [];
            if (usedViews.length === viewingPool) usedViews = [];
            let usedAdds = JSON.parse(sessionStorage.getItem('adds')) || [];
            if (usedAdds.length === addsPool) usedAdds = [];

            const viewIndex = randomNumber(viewingPool, usedViews);
            usedViews.push(viewIndex);
            viewing[viewIndex].classList.add('active');

            setTimeout(() => {
                // hide viewing and show random add items that has not been seen this session
                viewing[viewIndex].classList.remove('active');
                const addsIndex = randomNumber(addsPool, usedAdds);
                usedAdds.push(addsIndex);

                // add index counts to session storage
                sessionStorage.setItem('views', JSON.stringify(usedViews));
                sessionStorage.setItem('adds', JSON.stringify(usedAdds));

                // delay on showing second popup
                setTimeout(() => {
                    adds[addsIndex].classList.add('active');
                    setTimeout(() => {
                        // hide adds
                        adds[addsIndex].classList.remove('active');
                    }, 3000);
                }, 2000)
            }, 3000);
        }, 5000);

        function randomNumber(maxValue, usedNums) {
            let index = Math.floor(Math.random() * maxValue);
            if (usedNums.includes(index)) {
                for (let i = 0; i < maxValue; i++) {
                    if (!usedNums.includes(i)) {
                        index = i;
                        break;
                    }
                }
            }
            return index;
        }
    }

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productV2SellingOptionInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV2SellingOptionPlan').value);
    }

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", async function () {
            // check for single image layout and variant images
            if (element.classList.contains('imageSwap')) {
                // swap active images
                section.querySelector('.productV2VisualSingle.active')?.classList.remove('active');
                section.querySelector(`.productV2VisualSingle[data-value="${element.value}"]`)?.classList.add('active');
            }

            // create array of selected option ids
            const optionIDs = [];
            section.querySelectorAll(".productV2OptionsValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.valueId);
            })

            // fetch updated variant data
            activeVariant = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());

            updateProduct().catch(e => console.error(e));
        });
    })

    async function updateProduct() {
        // check if variant wasn't found
        if (!activeVariant.id) {
            section.querySelector(".productV2ATC").disabled = true;
            section.querySelector(".productV2ATCText").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image && swiperExists) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        // swap swipers if available
        if (multipleSwipers) {
            section.querySelectorAll('.productV2VisualAltItem').forEach(swiper => {
                const id = section.querySelector('.productV2OptionsValuesLabelInput:checked')?.dataset.id || null
                if (id) {
                    id === swiper.dataset.id
                        ? swiper.classList.add('active') : swiper.classList.remove('active');
                }
            })
        }

        /**************
         Quantity
         ***************/

        quantity = parseInt(section.querySelector('.productV2QuantitySelectItemInput:checked')?.value);

        /**************
         Price
         ***************/

            // check for a quantity discount and get the updated pricing, if applicable
        let discount = 0;

        if (section.querySelector('.productV2QuantitySelectItemInput:checked')?.dataset?.discount !== "0") {
            discount = parseInt(section.querySelector('.productV2QuantitySelectItemInput:checked').dataset.discount) * 100;
        }
        let allocationPrice = activeVariant.selling_plan_allocations[0].price * quantity;
        let originalPrice = activeVariant.price * quantity;
        let discountedPrice = activeVariant.price * quantity;
        let compareAt = activeVariant.compare_at_price * quantity || 0;

        if (discount !== 0) {
            allocationPrice -= discount;
            discountedPrice -= discount;
        }

        // if there's a subscription we need to update both prices
        if (hasSubscription) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV2SellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productV2SellingOptionHeaderPriceReal");

            // Destructure them for clarity, otp comes first on DOM
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            // Update subscription prices
            originalPrice > allocationPrice ? subCompare.textContent = price(originalPrice) : subCompare.textContent = "";
            subReal.textContent = price(allocationPrice);

            // Update one-time purchase prices
            if (compareAt > discountedPrice) {
                oneTimeCompare.textContent = price(compareAt);
            } else if (originalPrice > discountedPrice) {
                oneTimeCompare.textContent = price(originalPrice);
            } else {
                oneTimeCompare.textContent = "";
            }
            oneTimeReal.textContent = price(discountedPrice);

        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productV2SellingOptionHeaderPriceCompare");
            const realEl = section.querySelector(".productV2SellingOptionHeaderPriceReal");

            // check that the OTC is included
            if (realEl) {
                if (compareAt > discountedPrice) {
                    compareEl.textContent = price(compareAt);
                } else if (originalPrice > discountedPrice) {
                    compareEl.textContent = price(originalPrice);
                }
                realEl.textContent = price(discountedPrice);
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (section.querySelector(".productV2ATC").dataset.text) {
            section.querySelector(".productV2ATCText").textContent = section.querySelector(".productV2ATC").dataset.text;
        } else {
            if (activeVariant.available) {
                section.querySelector(".productV2ATC").disabled = false;
                section.querySelector(".productV2ATCText").textContent = "Add To Cart";
            } else {
                section.querySelector(".productV2ATC").disabled = true;
                section.querySelector(".productV2ATCText").textContent = "Sold Out";
            }
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(e => console.error(e));

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV2ATC").classList.add("loading");

        // see if the selected variant is a pre-order item
        const properties = {};
        if (section.querySelector('.productV2OptionsValuesLabelInput:checked')?.dataset?.message) {
            properties.Preorder = section.querySelector('.productV2OptionsValuesLabelInput:checked')?.dataset?.message;
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
                properties: properties
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan();
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV2ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV2ATC').addEventListener("click", addToCart);

});